import { BaseEntity } from '@models';
import { AdminErrorType } from './admin-error-type.enum';

export class NegativeCalculationData {
	organizationId: string;
	fleetVehicleId: string;
	mappedCarModelId: string;
	proposedCarModelId: string;
	brand: string;
	model: string;
	version: string;
}

export class AdminError extends BaseEntity {
	adminErrorType: AdminErrorType;
	adminErrorPayload: NegativeCalculationData;
}
